import type { IconSvgObject } from './types';

const AlignStartVerticalIcon: IconSvgObject = [
  ["path", { d: "M9 5L19 5C20.1046 5 21 5.89543 21 7V8C21 9.10457 20.1046 10 19 10H9C7.89543 10 7 9.10457 7 8V7C7 5.89543 7.89543 5 9 5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M9 14L13 14C14.1046 14 15 14.8954 15 16V17C15 18.1046 14.1046 19 13 19H9C7.89543 19 7 18.1046 7 17V16C7 14.8954 7.89543 14 9 14Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M3 3V21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default AlignStartVerticalIcon;
